"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var util_1 = require("../util");

var State_1 = require("../State");

var renderProp_1 = require("../util/renderProp");

var faccToHoc_1 = require("../util/faccToHoc");

exports.Toggle = function (props) {
  return util_1.h(State_1.State, {
    init: {
      on: props.init || false
    },
    render: function render(_a, _set) {
      var on = _a.on;
      return renderProp_1.default(props, {
        on: on,
        toggle: function toggle() {
          return _set({
            on: !on
          });
        },
        set: function set(on) {
          return _set({
            on: on
          });
        }
      });
    }
  });
};

exports.withToggle = faccToHoc_1.default(exports.Toggle, 'toggle');